import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Info, ArrowLeft } from "lucide-react";
import OrganicShapes from "@/components/OrganicShapes";
import TreeDetailView from "@/components/tracker/TreeDetailView";
import { fetchTreeById } from "@/lib/api";

export default function TreeDetail() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let alive = true;
        setLoading(true);
        setError("");
        fetchTreeById(id)
            .then((d) => alive && setData(d))
            .catch(() => alive && setError("We couldn't find a tree with that ID."))
            .finally(() => alive && setLoading(false));
        return () => {
            alive = false;
        };
    }, [id]);

    return (
        <main className="bg-white pt-32 pb-24 relative overflow-hidden min-h-screen">
            <OrganicShapes variant="mixed" />
            <section className="max-w-6xl mx-auto px-6 md:px-10 relative">
                <Link to="/tracker" className="inline-flex items-center gap-1.5 text-sm text-seedh-blue link-underline mb-8">
                    <ArrowLeft className="w-4 h-4" /> Back to tracker
                </Link>
                {loading ? (
                    <div className="rounded-2xl border border-dashed border-seedh-border p-12 text-center text-seedh-muted">Loading tree…</div>
                ) : error ? (
                    <div className="rounded-2xl border border-seedh-border p-12 text-center bg-seedh-surface-beige/40">
                        <Info className="w-7 h-7 text-seedh-brown mx-auto" />
                        <div className="font-display text-2xl text-seedh-text mt-4">Tree not found</div>
                        <p className="text-sm text-seedh-muted mt-2">{error}</p>
                    </div>
                ) : (
                    <TreeDetailView data={data} />
                )}
            </section>
        </main>
    );
}
